import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
import React from 'react';
import i18n from 'i18n';
import { getTeamIcon, TEAM_ICONS } from 'utils/icons';
import AssetIcon from 'components/AssetIcon';
import EasyTooltip from 'components/EasyTooltip';
import { jsx as _jsx } from "react/jsx-runtime";
function getTeamTooltip(_ref) {
  var teamType = _ref.teamType,
    isSmartTeam = _ref.isSmartTeam;
  if (teamType) {
    if (isSmartTeam) {
      return "".concat(teamType.name, " (").concat(i18n.t('content_type_smart_team'), ")");
    } else {
      return teamType.name;
    }
  }
  if (isSmartTeam) {
    return i18n.t('content_type_smart_team');
  } else {
    return null;
  }
}
function renderTeamTypeIcon(item) {
  var _item$teamType;
  if (!item.id) {
    return null;
  }
  return /*#__PURE__*/_jsx(EasyTooltip, {
    content: getTeamTooltip(item),
    children: /*#__PURE__*/_jsx(AssetIcon, {
      square: true,
      name: getTeamIcon(item.isSmartTeam),
      color: ((_item$teamType = item.teamType) === null || _item$teamType === void 0 ? void 0 : _item$teamType.colour) || TEAM_ICONS.TEAM
    })
  });
}
export default renderTeamTypeIcon;